import {usePrevious} from 'react-use'

import {MODE} from '@/constants/config'
import {CartRoute, FlightDetailsRoute, PaymentRoute} from '@/routeRegistry'

const STRIPE_ROUTES = [CartRoute, FlightDetailsRoute, PaymentRoute] as const

export default memo(function ReloadIfNotUsingStripeAnymore() {
  const isCurrentRouteUseStripe = STRIPE_ROUTES.map(route => {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks -- it's safe
    return !!useMatch({
      from: route.id,
      strict: true,
      shouldThrow: false,
    })
  }).some(Boolean)
  const isPreviousRouteUseStripe = usePrevious(isCurrentRouteUseStripe)

  // console.log(isPreviousRouteUseStripe, isCurrentRouteUseStripe)

  if (
    MODE !== 'development' &&
    isPreviousRouteUseStripe &&
    !isCurrentRouteUseStripe &&
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- can run in env where location is not available
    globalThis?.location?.reload
  )
    globalThis.location.reload()

  return null
})
